import React, {
  useState,
  Fragment,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react";
import { useFsideBar } from "./hooks/useFsideBar";
import "./style/FSideBar.css";
import { Dialog, Transition } from "@headlessui/react";
import jwt_decode from "jwt-decode";
import FiconPhoneNumber from "../../components/FiconPhoneNumber/FiconPhoneNumber";
import { putPreferredName } from "../../api/auth";
import { useFormat } from "../../hooks/useFormat";
import { putProfilePicture } from "../../api/auth";
import Webcam from "react-webcam";
import {
  CreateOutline,
  ReceiptOutline,
  PersonOutline,
  CardOutline,
  BusinessOutline,
  BookOutline,
  CogOutline,
  EnterOutline,
} from "react-ionicons";

import {
  CreditCardIcon,
  UsersIcon,
  CogIcon,
  CashIcon,
  OfficeBuildingIcon,
  XIcon,
  DocumentAddIcon,
} from "@heroicons/react/outline";
import { Link, useNavigate } from "react-router-dom";
import { getProfilePicture } from "../../api/auth";
import { AuthContext } from "../../context/AuthContext";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Fbutton from "../Finputs/FButton/Fbutton";
import VectorIcons from "../VectorIcons/VectorIcons";
import FInputText from "../Finputs/FInputText/FInputText";
import { useFormik } from "formik";
import { useKyc } from "../../hooks/useKyc";
import { size } from "lodash";
import Compress from "react-image-file-resizer";

const SideBarNavigationArray = [
  {
    name: "Envía tus documentos",
    href: "/MenuKycScreen",
    icon: DocumentAddIcon,
  },

  { name: "Mis Datos", href: "/ProfileOptionsScreen", icon: UsersIcon },
  { name: "Mis Tarjetas", href: "/CardsScreen", icon: CreditCardIcon },
  { name: "Mis Bancos", href: "/BankScreen", icon: OfficeBuildingIcon },
  { name: "Mis Fiados", href: "#", icon: CashIcon },
  { name: "Ajustes", href: "/ConfigScreen", icon: CogIcon },
];

const FsideBar = ({ sidebarOpen, setSidebarOpen }) => {
  const MySwal = withReactContent(Swal);

  useEffect(() => {
    getPicture();
    console.log(profilePicture);
  }, []);

  const { getBase64 } = useFormat();
  const [srcFileZoneSideBar, setSrcFileZoneSideBar] = useState();
  const [active, setActive] = useState(0);
  const tokennn = localStorage.getItem("token");
  const tokenDecode = jwt_decode(tokennn);
  const route = useNavigate();

  const {
    setLoading,
    tokenDecoded,
    profilePicture,
    setProfilePicture,
    setPathname,
    tokenn,
    setTokenn,
    setAlert,
    checkToken,
    resetContext
  } = useContext(AuthContext);

  //console.log(tokenDecode)



  const getPicture = async () => {
    checkToken();
    try {
      const { data } = await getProfilePicture();
      const imageBase64 = data.data.profilePicture;
      //console.log(data.data.profilePicture)
      setProfilePicture(`data:image/gif;base64,${imageBase64}`);
      return true;
    } catch (e) {
      console.log(e.response);
      return false;
    }
  };

  const updateProfilePicture = async (image) => {
    checkToken();
    try {
      var img = image.replace(/^data:image\/[a-z]+;base64,/, "");
      setLoading(true);
      await putProfilePicture(img);
      setLoading(false);
      getPicture();
      return true;
    } catch (e) {
      setLoading(false);
      console.log(e);
      return false;
    }
  };

  let editName = async () => {
    MySwal.fire({
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      html: <MySwalSetName MySwal={MySwal} />
    });
  };

  const editImage = async () => {
    MySwal.fire({
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <MySwalQuestionSetImage
          setProfilePicture={setProfilePicture}
          profilePicture={profilePicture}
          updateProfilePicture={updateProfilePicture}
        />
      ),
    });
  };
  

  const { refreshToken } = useKyc();

  const MySwalSetName = ({ MySwal }) => {
    
    const [preferredName, setPreferredName] = useState('');
    
    const changeName = async (data) => {
      checkToken();
      try {
        setLoading(true)
        await putPreferredName(data);
        setLoading(false)
        return true;
      } catch (e) {
        setLoading(false)
        console.log(e.response)
        return false;
      }
    }
    const nextScreen = async (data) => {
      const datos = {
        preferedNameToDisplay: data,
      }
      const response = await (changeName(datos));
      if (response === true) {
        Swal.fire({
          showCloseButton: true,
          icon: 'success',
          title: 'Su nombre ha sido cambiado con éxito',
          showConfirmButton: false,
          timer: 1500
        })  
          refreshToken();
      } else {
        console.log('error')
      }
    }

    return (
      <>
        <div className="border-0 w-full grid grid-cols-1">
          <div className="border-0 col-span-1 grid place-items-center">
            <img
              className="inline-block h-[120px] w-[120px] rounded-full mb-5"
              src={require("../../components/assets/images/profile.png")}
            />
          </div>
          <div className="border-0 col-span-1 grid place-items-center text-black font-bold text-2xl">
            Nombre preferido
          </div>
          <div className="border-0 col-span-1 grid place-items-center xss:px-14 smm:px-20">
            <FInputText
              placeholder="Ej: Juanito"
              onChange={(e) => setPreferredName(e)}
              value={preferredName}
              type="text"
            />
          </div>
          <div className="border-0 col-span-1 grid place-items-center xss:px-14  smm:px-20">
            <Fbutton value="Confirmar" disabled={(size(preferredName) > 0) ? false : true}  onClick={() => nextScreen(preferredName)} />
          </div>
        </div>
      </>
    );
  };

  


  return (
    <div>
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-[60] md:hidden"
          onClose={() => {
            setSidebarOpen(false);
            setPathname(999);
          }}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
          </Transition.Child>

          <div className="fixed inset-0 flex z-40">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative flex-1 flex flex-col max-w-xs w-full pb-4 bg-white">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute top-0 right-0 -mr-12 pt-2">
                    <button
                      type="button"
                      className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                      onClick={() => {
                        setPathname(999);
                        setSidebarOpen(false);
                      }}
                    >
                      <span className="sr-only">Close sidebar</span>
                      <XIcon
                        className="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </Transition.Child>
                <div className="h-screen overflow-auto pr-5">
                  <div className="mb-20">
                  <div className="border-0 flex-shrink-0 flex items-center mx-3 py-4">
                      <div onClick={editImage} className="cursor-pointer h-[60px] sm:h-[70px] w-[60px] sm:w-[70px] pr-1">
                        <img
                          className="inline-block w-full h-auto rounded-full profile-picture-sidebar"
                          src={
                            !profilePicture
                              ? require("../../components/assets/images/profile.png")
                              : profilePicture
                          }
                        />
                      </div>
                      <div className="border-0 h-auto font-bold text-black text-[12px] sm:text-[14px]">
                        <div  className="cursor-pointer" onClick={editName}>
                          {tokenDecode.preferredName}
                          <CreateOutline
                            cssClasses={"mr-5 float-right"}
                            height="18px"
                            width="18px"
                          />
                          
                          <br />
                        </div>
                        <div className="pt-1 text-[11px] sm:text-[14px]">
                          <FiconPhoneNumber
                            sizeIcon="18px"
                            phoneNumber={tokenDecode.phoneNumber}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="px-3">
                      <div className="w-full border-[1px]"></div>
                    </div>
                    <div className="flex-shrink-0 flex items-center px-5 py-4 ">
                      <div className="text-[#c2c2c2] font-medium text-large">
                        Perfil
                      </div>
                    </div>
                    <div
                      onClick={() => {
                        route("/ProfileOptionsScreen");
                        setSidebarOpen(false);
                      }}
                      key={"ProfileOptionsScreen"}
                      className="flex-shrink-0 flex items-center px-5 mt-7 cursor-pointer"
                    >
                      <div className="border-b-[1px] pb-2 w-full grid grid-cols-12">
                        <div className="col-span-11 font-regular text-[16px]">
                          Mis datos
                        </div>
                        <div className="col-span-1">
                          <PersonOutline
                            cssClasses={"ml-1 float-left cursor-pointer"}
                            height="25px"
                            width="25px"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      onClick={() => {
                        route("/CardsScreen");
                        setSidebarOpen(false);
                      }}
                      key={"CardsScreen"}
                      className="flex-shrink-0 flex items-center px-5 mt-5 cursor-pointer"
                    >
                      <div className="border-b-[1px] pb-2 w-full grid grid-cols-12">
                        <div className="col-span-11 font-regular text-[16px]">
                          Mis tarjetas
                        </div>
                        <div className="col-span-1">
                          <CardOutline
                            cssClasses={"ml-1 float-left cursor-pointer"}
                            height="25px"
                            width="25px"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      onClick={() => {
                        route("/BankScreen");
                        setSidebarOpen(false);
                      }}
                      key={"BankScreen"}
                      className="flex-shrink-0 flex items-center px-5 mt-5 cursor-pointer"
                    >
                      <div className="border-b-[1px] pb-2 w-full grid grid-cols-12">
                        <div className="col-span-11 font-regular text-[16px]">
                          Mis bancos
                        </div>
                        <div className="col-span-1">
                          <BusinessOutline
                            cssClasses={"ml-1 float-left cursor-pointer"}
                            height="25px"
                            width="25px"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      onClick={() => {
                        route("/LegalNotices");
                        setSidebarOpen(false);
                      }}
                      key={"LegalNotices"}
                      className="flex-shrink-0 flex items-center px-5 mt-5 cursor-pointer"
                    >
                      <div className="border-b-[1px] pb-2 w-full grid grid-cols-12">
                        <div className="col-span-11 font-regular text-[16px]">
                          Avisos Legales
                        </div>
                        <div className="col-span-1">
                          <BookOutline
                            cssClasses={"ml-1 float-left cursor-pointer"}
                            height="25px"
                            width="25px"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      onClick={() => {
                        route("/ConfigScreen");
                        setSidebarOpen(false);
                      }}
                      key={"ConfigScreen"}
                      className="flex-shrink-0 flex items-center px-5 mt-5 cursor-pointer"
                    >
                      <div className="border-b-[1px] pb-2 w-full grid grid-cols-12">
                        <div className="col-span-11 font-regular text-[16px]">
                          Ajustes
                        </div>
                        <div className="col-span-1">
                          <CogOutline
                            cssClasses={"ml-1 float-left"}
                            height="25px"
                            width="25px"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex-shrink-0 flex items-center px-5 mt-8">
                      <button
                        className=" bg-primary rounded-2xl shadow-lg grid place-items-center font-medium text-white px-10 py-3"
                        onClick={() => {
                          resetContext()
                          localStorage.removeItem("token");
                          setTokenn(null);
                          route("/Login");
                        }}
                      >
                        <div>
                          <p className="float-left font-medium text-[14px] ">
                            Cerrar Sesión
                          </p>
                          <EnterOutline
                            cssClasses={"ml-1 float-left"}
                            color="white"
                            height="25px"
                            width="25px"
                          />
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
            <div className="flex-shrink-0 w-14" aria-hidden="true">
              {/* Dummy element to force sidebar to shrink to fit close icon */}
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
        <div className="flex-1 flex flex-col min-h-0 bg-[#f9fbfc] shadow-2xl">
          <div className="h-screen overflow-auto pr-5">
            <div className="mb-20">
              {" "}
              <div className="border-0 flex-shrink-0 flex items-center mx-3 py-4">
                      <div onClick={editImage} className="cursor-pointer h-[60px] sm:h-[70px] w-[60px] sm:w-[70px] pr-1">
                        <img
                          className="inline-block w-full h-auto rounded-full profile-picture-sidebar"
                          src={
                            !profilePicture
                              ? require("../../components/assets/images/profile.png")
                              : profilePicture
                          }
                        />
                      </div>
                      <div className="border-0 h-auto font-bold text-black text-[12px] sm:text-[14px]">
                        <div  className="cursor-pointer" onClick={editName}>
                          <CreateOutline
                            cssClasses={"float-right mr-5"}
                            height="18px"
                            width="18px"
                          />
                          {tokenDecode.preferredName}
                          <br />
                        </div>
                        <div className="pt-1 text-[11px] sm:text-[14px]">
                          <FiconPhoneNumber
                            sizeIcon="18px"
                            phoneNumber={tokenDecode.phoneNumber}
                          />
                        </div>
                      </div>
                    </div>
              <div className="px-3">
                <div className="w-full border-[1px]"></div>
              </div>
              <div className="flex-shrink-0 flex items-center px-5 py-4">
                <div className="text-[#c2c2c2] font-medium text-large">
                  Perfil
                </div>
              </div>
              <div
                onClick={() => {
                  route("/ProfileOptionsScreen");
                  setSidebarOpen(false);
                }}
                key={"ProfileOptionsScreen"}
                className="flex-shrink-0 flex items-center px-5 mt-7 cursor-pointer"
              >
                <div className="border-b-[1px] pb-2 w-full grid grid-cols-12">
                  <div className="col-span-11 font-regular text-[16px]">
                    Mis datos
                  </div>
                  <div className="col-span-1">
                    <PersonOutline
                      cssClasses={"ml-1 float-left cursor-pointer"}
                      height="25px"
                      width="25px"
                    />
                  </div>
                </div>
              </div>
              <div
                onClick={() => {
                  route("/CardsScreen");
                  setSidebarOpen(false);
                }}
                key={"CardsScreen"}
                className="flex-shrink-0 flex items-center px-5 mt-5 cursor-pointer"
              >
                <div className="border-b-[1px] pb-2 w-full grid grid-cols-12">
                  <div className="col-span-11 font-regular text-[16px]">
                    Mis tarjetas
                  </div>
                  <div className="col-span-1">
                    <CardOutline
                      cssClasses={"ml-1 float-left cursor-pointer"}
                      height="25px"
                      width="25px"
                    />
                  </div>
                </div>
              </div>
              <div
                onClick={() => {
                  route("/BankScreen");
                  setSidebarOpen(false);
                }}
                key={"BankScreen"}
                className="flex-shrink-0 flex items-center px-5 mt-5 cursor-pointer"
              >
                <div className="border-b-[1px] pb-2 w-full grid grid-cols-12">
                  <div className="col-span-11 font-regular text-[16px]">
                    Mis bancos
                  </div>
                  <div className="col-span-1">
                    <BusinessOutline
                      cssClasses={"ml-1 float-left cursor-pointer"}
                      height="25px"
                      width="25px"
                    />
                  </div>
                </div>
              </div>
              <div
                onClick={() => {
                  route("/LegalNotices");
                  setSidebarOpen(false);
                }}
                key={"LegalNotices"}
                className="flex-shrink-0 flex items-center px-5 mt-5 cursor-pointer"
              >
                <div className="border-b-[1px] pb-2 w-full grid grid-cols-12">
                  <div className="col-span-11 font-regular text-[16px]">
                    Avisos Legales
                  </div>
                  <div className="col-span-1">
                    <BookOutline
                      cssClasses={"ml-1 float-left cursor-pointer"}
                      height="25px"
                      width="25px"
                    />
                  </div>
                </div>
              </div>
              <div
                onClick={() => {
                  route("/ConfigScreen");
                  setSidebarOpen(false);
                }}
                key={"ConfigScreen"}
                className="flex-shrink-0 flex items-center px-5 mt-5 cursor-pointer"
              >
                <div className="border-b-[1px] pb-2 w-full grid grid-cols-12">
                  <div className="col-span-11 font-regular text-[16px]">
                    Ajustes
                  </div>
                  <div className="col-span-1">
                    <CogOutline
                      cssClasses={"ml-1 float-left"}
                      height="25px"
                      width="25px"
                    />
                  </div>
                </div>
              </div>
              <div className="flex-shrink-0 flex items-center px-5 mt-8">
                <button
                  className=" bg-primary rounded-2xl shadow-lg grid place-items-center font-medium text-white px-10 py-3"
                  onClick={() => {
                    resetContext()
                    localStorage.removeItem("token");
                    setTokenn(null);
                    route("/Login");
                  }}
                >
                  <div>
                    <p className="float-left font-medium text-[13px] ">
                      Cerrar Sesión
                    </p>
                    <EnterOutline
                      cssClasses={"ml-1 float-left"}
                      color="white"
                      height="25px"
                      width="25px"
                    />
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const MySwalQuestionSetImage = ({ setProfilePicture, profilePicture, updateProfilePicture }) => {
  const MySwal = withReactContent(Swal);
  const { getBase64 } = useFormat();
  const [permitionCamara, setPermitionCamara] = useState(true);

  useEffect(() => {
    if (navigator.webkitGetUserMedia != null) {
      navigator.webkitGetUserMedia(
        {
          video: true,
        },
        function (stream) {
          stream.getTracks()[0].stop();
          setPermitionCamara(true);
        },
        function (e) {
          setPermitionCamara(false);
        }
      );
    }
  }, []);

  const onFileResize = e => {
    const file = e.target.files[0];
  
    Compress.imageFileResizer(
        file, // the file from input
        500, // width
        500, // height
        "JPEG", // compress format WEBP, JPEG, PNG
        70, // quality
        0, // rotation
        (uri) => {
          MySwal.fire({
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: false,
            html: (
              <MySwalViewImage
                imageSrc={uri}
                setProfilePicture={setProfilePicture}
                updateProfilePicture={updateProfilePicture}
              />
            ),
          });
        },
        "base64" // blob or base64 default base64
      );
  };

  return (
    <>
      <img className="w-full shadow-xl pb-5" src={profilePicture} />

      <label>
        <div
          className={`w-full font-medium py-[11px] text-[15px] rounded-[14px] bg-primary text-white cursor-pointer
          }`}
        >
          Elegir de la galería
        </div>
        <input
          id="dropzone-fileSideBar2"
          type="file"
          className="hidden"
          onChange={onFileResize}
          accept="image/png, image/gif, image/jpeg"
        />
      </label>
      <Fbutton
        value="Tomar Foto"
        disabled={!permitionCamara}
        onClick={() => {
          MySwal.fire({
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: false,
            html: (
              <MySwalSetImageWebCam setProfilePicture={setProfilePicture} updateProfilePicture={updateProfilePicture} />
            ),
          });
        }}
      />
      <p
        className={`text-error font-bold text-left text-small ${permitionCamara ? "hidden" : ""
          }`}
      >
        {"Activar los permisos a la camara"}
      </p>
    </>
  );
};

const MySwalSetImageWebCam = ({ setProfilePicture, updateProfilePicture }) => {
  const MySwal = withReactContent(Swal);
  const webcamRef = useRef(null);
  const capture = useCallback(() => {

    const imageSrc = webcamRef.current.getScreenshot(); 
    MySwal.fire({
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <MySwalViewImage
          imageSrc={imageSrc}
          setProfilePicture={setProfilePicture}
          updateProfilePicture={updateProfilePicture}
        />
      ),
    });
  }, [webcamRef]);

  return (
    <>
      <Webcam
        audio={false}
        height={500}
        screenshotFormat="image/jpeg"
        width={500}
        ref={webcamRef}
        videoConstraints={{
          width: 500,
          height: 500,
          facingMode: "user",
        }}
      />
      <Fbutton value="Tomar foto" onClick={capture} />
    </>
  );
};

const MySwalViewImage = ({ imageSrc, setProfilePicture, updateProfilePicture }) => {
  const MySwal = withReactContent(Swal);

  const SalveImage = async () => {
    setProfilePicture(imageSrc);
    updateProfilePicture(imageSrc);
    MySwal.close();
  };

  return (
    <>
      <img className="w-full shadow-xl" src={imageSrc} />
      <Fbutton value="Guardar" onClick={SalveImage} />
    </>
  );
};



export default FsideBar;
